export default "__VITE_PUBLIC_ASSET__f0226b97__"